import {Validatable} from './validatable'

export abstract class FormValidationService {
  abstract subscribe(validatable: Validatable<any>): void
  abstract unsubscribe(validatable: Validatable<any>): void
  abstract validateAll(onSuccess: Function, onFailure: Function): void
}
